import type { UseModalState } from "@src/appV2/redesign/system/ui-components";

import { OpenGeoLocationBottomSheet } from "../../OpenGeoLocation/OpenGeoLocationBottomSheet";
import {
  OpenGeoLocationProvider,
  useOpenGeoLocationContext,
} from "../../OpenGeoLocation/useOpenGeoLocation";
import { type ModalShiftData } from "../types";
import {
  ShortLeadTimeShiftBookedBottomSheet,
  type ShortLeadTimeShiftBookedBottomSheetProps,
} from "./ShortLeadTimeShiftBookedBottomSheet";

export interface ShortLeadTimeShiftBookedBottomSheetContainerProps {
  modalState: UseModalState;
  shift: ModalShiftData;
}

export function ShortLeadTimeShiftBookedBottomSheetContainer(
  props: ShortLeadTimeShiftBookedBottomSheetContainerProps
) {
  const { modalState, shift } = props;

  return (
    <OpenGeoLocationProvider
      location={{
        lat: shift.workplace.attributes.location.latitude,
        lng: shift.workplace.attributes.location.longitude,
      }}
      name={shift.workplace.attributes.name}
      formattedAddress={shift.workplace.attributes.fullAddress?.formatted}
    >
      <ShortLeadTimeShiftBookedBottomSheetWithLocation
        modalState={modalState}
        workplaceName={shift.workplace.attributes.name}
      />

      <OpenGeoLocationBottomSheet />
    </OpenGeoLocationProvider>
  );
}

function ShortLeadTimeShiftBookedBottomSheetWithLocation(
  props: Omit<ShortLeadTimeShiftBookedBottomSheetProps, "onGetDirectionsClick" | "directionsHref">
) {
  const { href, onClick } = useOpenGeoLocationContext();

  return (
    <ShortLeadTimeShiftBookedBottomSheet
      {...props}
      directionsHref={href}
      onGetDirectionsClick={onClick}
    />
  );
}
